import { render, staticRenderFns } from "./userEditor.vue?vue&type=template&id=2f1581fd"
import script from "./userEditor.vue?vue&type=script&lang=js"
export * from "./userEditor.vue?vue&type=script&lang=js"
import style0 from "./userEditor.vue?vue&type=style&index=0&id=2f1581fd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports